import { render, staticRenderFns } from "./PhraseTune.vue?vue&type=template&id=5d118777&scoped=true"
import script from "./PhraseTune.vue?vue&type=script&lang=js"
export * from "./PhraseTune.vue?vue&type=script&lang=js"
import style0 from "./PhraseTune.vue?vue&type=style&index=0&id=5d118777&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d118777",
  null
  
)

export default component.exports